<div class="container-modal">
    <mat-spinner *ngIf="modal" color="white"></mat-spinner>
    <div *ngIf="!modal" class="container-form" [ngSwitch]="channel">
        <form [formGroup]="unsubscribeForm" *ngSwitchCase="'o'">
            <div class="others">
                <p>{{ (!message)? 'Introduce email para darse de baja' : message }}</p>
                <input type="text" placeholder="Email" *ngIf="!message" formControlName="email" id="emailUnsubscribe">
            </div>
            <button class="btn-unsubscribe" id="accept"
                (click)="unsubscriptionMethod()">{{ (!message) ? 'Enviar' : 'Aceptar' }}</button>
        </form>
        <form *ngSwitchCase="'wp'">
            <div class="wp" *ngSwitchCase="'wp'">
                <p>{{ (!message)? 'Al pulsar en Aceptar, se procedera a darse de baja en el servicio' : message }}</p>
            </div>
            <button class="btn-unsubscribe" id="accept" (click)="othersUnsubscription()">Aceptar</button>
        </form>
    </div>
</div>